'use client'

import { useState } from 'react'
import { useDeliveryAddress } from '@/stores/useAddressStore'

import { OrderForm } from '@/app/[locale]/(common)/order-form'
import { Alert } from '@/app/[locale]/(ui)/alert'
import { trackOrderCompleted } from '@/lib/tracking'
import { useTranslations } from 'next-intl'
import { SignInNewsBanner } from '@/app/[locale]/(global)/sign-in-news-banner'
import { GuestOrder } from '@/types/orders'
import { createGuestOrder } from '@/lib/orders'

const BedriftPage = () => {
  const t = useTranslations()
  const deliveryAddress = useDeliveryAddress()
  const [hasError, setHasError] = useState(false)
  const [hasSuccess, setHasSuccess] = useState(false)

  const onSubmit = async (order: GuestOrder) => {
    if (!deliveryAddress) return
    setHasError(false)
    setHasSuccess(false)

    try {
      await createGuestOrder(order)
    } catch {
      return setHasError(true)
    }

    setHasSuccess(true)
    trackOrderCompleted({
      cart: [],
      total: { gross: 0 },
      customerType: 'business',
      orderType: 'waste',
      origin: 'form',
    })
  }

  return (
    <div className="flex flex-col items-center justify-center pt-8">
      <div className="px-6 sm:px-8">
        <SignInNewsBanner />
      </div>
      <div className="w-full max-w-screen-sm bg-gray-100 p-8 sm:rounded-xl">
        <OrderForm key={`${hasSuccess}`} onSubmit={onSubmit} customerType="business" />
        {hasSuccess && (
          <Alert variant="success" className="mt-4">
            {t('We_have_received_your_order')}
          </Alert>
        )}
        {hasError && (
          <Alert variant="error" className="mt-4">
            {t('Error_sending_order')}
          </Alert>
        )}
      </div>
    </div>
  )
}

export default BedriftPage
